module.exports = __webpack_public_path__ + "img/dscp-banner.aa8d88ee.jpg";